export default class ImageApi {
    getImageUrl({ src }) {
        return { src }
    }
}
